var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenuArrow = function SvgMenuArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 7",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 .5 5 5 5-5H0Z"
  })));
};
export { SvgMenuArrow as ReactComponent };
export default "data:image/svg+xml,%3csvg version='1.1' viewBox='0 0 10 7' xmlns='http://www.w3.org/2000/svg'%3e %3cg id='Page-1' stroke='none'%3e %3cg id='Core' transform='translate(-469.000000, -9.000000)'%3e %3cg id='arrow-drop-down' transform='translate(469.000000, 9.500000)'%3e %3cpath d='M0,0 L5,5 L10,0 L0,0 Z' id='Shape' /%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/svg%3e";